(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  /*
   * /collections/all landing: client-side filter + sort (LF-style sheet).
   *
   * Fully DOM-driven: the grid's <li> elements carry data-price / data-bs /
   * data-colors rendered by Liquid, and this code only shows/hides/reorders
   * those existing elements — no reloads, no Shopify filter URLs, and the
   * product-card pair/add-to-cart logic inside the cards is never touched.
   * The bundle loads on every page, so everything is guarded on the landing
   * markup actually being present.
   */
  (function () {
    var bar = document.querySelector('[data-landing-filter-bar]');
    var sheet = document.querySelector('[data-filter-sheet]');
    var grid = document.querySelector('.collection__grid--landing');
    if (!bar || !sheet || !grid) return;

    var openBtn = bar.querySelector('[data-filter-open]');
    var countEl = bar.querySelector('[data-filter-count]');
    var template = (countEl && countEl.getAttribute('data-count-template')) || '%d';
    var emptyEl = document.querySelector('[data-filter-empty]');
    var bsInput = sheet.querySelector('[data-f-bs]');
    var priceInputs = Array.prototype.slice.call(sheet.querySelectorAll('[data-f-price]'));
    var sortSelect = sheet.querySelector('[data-f-sort]');
    var applyBtn = sheet.querySelector('[data-filter-apply]');
    var clearBtn = sheet.querySelector('[data-filter-clear]');
    var resetLink = document.querySelector('[data-filter-reset]');
    // Original DOM order = the curated "Best seller" default sort.
    var items = Array.prototype.slice.call(grid.children);

    function price(li) {
      return parseInt(li.getAttribute('data-price'), 10) || 0;
    }

    function matches(li) {
      if (bsInput && bsInput.checked && li.getAttribute('data-bs') !== '1') return false;
      var buckets = priceInputs.filter(function (i) { return i.checked; });
      if (buckets.length) {
        var p = price(li);
        var inBucket = buckets.some(function (i) {
          var range = i.value.split('-');
          return p >= (parseInt(range[0], 10) || 0) && p <= (parseInt(range[1], 10) || 0);
        });
        if (!inBucket) return false;
      }
      return true;
    }

    function apply() {
      var mode = sortSelect ? sortSelect.value : 'best';
      var ordered = items.slice();
      if (mode === 'asc' || mode === 'desc') {
        ordered.sort(function (a, b) {
          var d = price(a) - price(b);
          if (mode === 'desc') d = -d;
          // Equal prices keep the curated order (stable tiebreak).
          return d || items.indexOf(a) - items.indexOf(b);
        });
      }
      ordered.forEach(function (li) { grid.appendChild(li); });

      var visible = 0;
      items.forEach(function (li) {
        var ok = matches(li);
        li.hidden = !ok;
        if (ok) visible += 1;
      });
      if (countEl) countEl.textContent = template.replace('%d', String(visible));
      if (emptyEl) emptyEl.hidden = visible !== 0;
    }

    function clearControls() {
      if (bsInput) bsInput.checked = false;
      priceInputs.forEach(function (i) { i.checked = false; });
      if (sortSelect) sortSelect.value = 'best';
    }

    function open() {
      sheet.hidden = false;
      void sheet.offsetWidth; // commit the hidden->visible frame before transitioning
      sheet.classList.add('is-open');
      document.body.classList.add('filter-sheet-lock');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      sheet.classList.remove('is-open');
      document.body.classList.remove('filter-sheet-lock');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        if (!sheet.classList.contains('is-open')) sheet.hidden = true;
      }, 320);
    }

    if (openBtn) openBtn.addEventListener('click', open);
    Array.prototype.slice.call(sheet.querySelectorAll('[data-filter-close]')).forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });

    if (applyBtn) applyBtn.addEventListener('click', function () { apply(); close(); });
    if (clearBtn) clearBtn.addEventListener('click', function () { clearControls(); apply(); });
    if (resetLink) resetLink.addEventListener('click', function () { clearControls(); apply(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('contact-form__form')) {
      return;
    }
    var button = form.querySelector('.contact-form__submit');
    if (!button) {
      return;
    }
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    var label = button.querySelector('.contact-form__submit-label');
    var loadingLabel = button.getAttribute('data-loading-label');
    if (label && loadingLabel) {
      label.textContent = loadingLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-list-controller')) {
    class ReviewsListController extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-review-list]');
        if (!this.list) return;

        this.initial = parseInt(this.getAttribute('data-initial'), 10) || 5;
        this.reveal = parseInt(this.getAttribute('data-reveal'), 10) || 5;

        this.moreWrap = this.querySelector('[data-more-wrap]');
        this.moreBtn = this.querySelector('[data-more-btn]');
        this.emptyMsg = this.querySelector('[data-empty]');
        this.sortRoot = this.querySelector('[data-sort-root]');
        this.sortToggle = this.querySelector('[data-sort-toggle]');
        this.sortMenu = this.querySelector('[data-sort-menu]');
        this.sortCurrent = this.querySelector('[data-sort-current]');
        this.sortOptions = Array.from(this.querySelectorAll('.rl-sort__option'));
        this.filterBtn = this.querySelector('[data-filter-photo]');

        // 'featured' keeps the server-rendered (per-product) order as the
        // default view; the sort controls still reorder on demand. Everywhere
        // else the default stays 'recent' (date), exactly as before.
        this.defaultSort = this.getAttribute('data-default-sort') || 'recent';
        this.sort = this.defaultSort;
        this.sortOptions.forEach(function (o) {
          o.setAttribute('aria-selected', o.getAttribute('data-sort') === this.defaultSort ? 'true' : 'false');
        }, this);
        this.photoOnly = false;
        this.shown = this.initial;

        this.items = Array.from(this.list.querySelectorAll('.rl-item')).map(function (el, i) {
          var parsed = Date.parse(el.getAttribute('data-review-date'));
          return {
            el: el,
            order: i,
            time: isNaN(parsed) ? null : parsed,
            rating: parseInt(el.getAttribute('data-review-rating'), 10) || 0,
            hasPhoto: el.getAttribute('data-review-has-photo') === 'true'
          };
        });

        this.bind();
        this.bindWrite();
        this.initLightbox();
        this.render();
      }

      /* ---- Write a review: open/close, validate, send via the native
         contact form without leaving the page, thank-you in place. ---- */
      bindWrite() {
        var self = this;
        this.writeToggle = this.querySelector('[data-write-toggle]');
        this.writePanel = this.querySelector('[data-write-panel]');
        if (!this.writeToggle || !this.writePanel) return;

        this.writeForm = this.writePanel.querySelector('form');
        this.writeFields = this.writePanel.querySelector('[data-write-fields]');
        this.writeDone = this.writePanel.querySelector('[data-write-done]');
        this.writeDoneText = this.writePanel.querySelector('[data-write-done-text]');
        this.writeError = this.writePanel.querySelector('[data-write-error]');
        this.writeSubmit = this.writePanel.querySelector('[data-write-submit]');
        this.writeStars = Array.from(this.writePanel.querySelectorAll('[data-write-star]'));
        this.writeStarInputs = Array.from(this.writePanel.querySelectorAll('[data-write-star-input]'));
        this.writeName = this.writePanel.querySelector('[data-write-name]');
        this.writeEmail = this.writePanel.querySelector('[data-write-email]');
        this.writeText = this.writePanel.querySelector('[data-write-text]');
        this.writeBody = this.writePanel.querySelector('[data-write-body]');
        this.writeProduct = this.writePanel.querySelector('[data-write-product]');
        this.writeHp = this.writePanel.querySelector('[data-write-hp]');
        this.writeCounter = this.writePanel.querySelector('[data-write-counter]');
        this.writePrefix = this.getAttribute('data-write-prefix') || 'NUOVA RECENSIONE DA MODERARE';

        // Reloaded after Shopify's own redirect: the thank-you (or a server
        // error) is rendered in place — open the panel and bring it into view.
        if (this.writePanel.querySelector('[data-write-posted], [data-write-server-error]')) {
          this.openWrite(false);
          var panel = this.writePanel;
          setTimeout(function () { panel.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 60);
          if (this.writePanel.querySelector('[data-write-posted]')) return;
        }

        this.writeToggle.addEventListener('click', function () {
          if (self.writePanel.hasAttribute('hidden')) self.openWrite(true);
          else self.closeWrite();
        });

        var cancel = this.writePanel.querySelector('[data-write-cancel]');
        if (cancel) cancel.addEventListener('click', function () { self.closeWrite(); self.writeToggle.focus(); });

        this.writeStarInputs.forEach(function (input, i) {
          input.addEventListener('change', function () { self.paintStars(i + 1); self.showWriteError('stars', false); self.syncBody(); });
        });

        if (this.writeText && this.writeCounter) {
          var max = parseInt(this.writeText.getAttribute('maxlength'), 10) || 600;
          var update = function () { self.writeCounter.textContent = self.writeText.value.length + '/' + max; };
          this.writeText.addEventListener('input', function () { update(); if (self.writeText.value.trim()) self.showWriteError('text', false); self.syncBody(); });
          update();
        }
        if (this.writeName) this.writeName.addEventListener('input', function () { if (self.writeName.value.trim()) self.showWriteError('name', false); });
        if (this.writeEmail) this.writeEmail.addEventListener('input', function () { if (self.validEmail(self.writeEmail.value)) self.showWriteError('email', false); });

        // Native constraint validation is the guard that holds whichever script
        // submits the form (Shopify's own spam-protection handler runs first on
        // contact forms); we only swap the browser bubble for our own messages.
        var self2 = this;
        [this.writeName, this.writeEmail, this.writeText].concat(this.writeStarInputs).forEach(function (field) {
          if (!field) return;
          field.addEventListener('invalid', function (e) {
            e.preventDefault();
            var key = field === self2.writeName ? 'name' : field === self2.writeEmail ? 'email' : field === self2.writeText ? 'text' : 'stars';
            self2.showWriteError(key, true);
            if (!self2._invalidScrolled) {
              self2._invalidScrolled = true;
              setTimeout(function () { self2._invalidScrolled = false; }, 300);
              var target = key === 'stars' ? self2.writePanel.querySelector('[data-write-stars]') : field;
              if (target && target.scrollIntoView) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          });
        });

        this.syncBody();

        if (this.writeForm) {
          this.writeForm.addEventListener('submit', function (e) { self.onWriteSubmit(e); });
        }
      }

      /* ONE submission path, no races. The contact form is posted natively by
         the browser (Shopify's spam-protection handler hooks this same event,
         runs its captcha, then completes that same native post — never a
         second one). We only sequence the states around it: the button locks
         and reads "Invio…" the moment the submit is accepted, error and
         thank-you stay hidden while the post is in flight, and the reloaded
         page renders the thank-you (or Shopify's own error) in this panel.
         A fetch in parallel would be a second submission and — aborted by the
         navigation — the source of a phantom error flash, so there is none. */
      onWriteSubmit(e) {
        if (this._sending) { e.preventDefault(); return; }
        if (this.writeError) this.writeError.hidden = true;
        if (!this.writeForm.checkValidity()) { e.preventDefault(); this.writeForm.reportValidity(); return; }
        if (this.writeHp && this.writeHp.value) { e.preventDefault(); this.showWriteDone(); return; }
        if (navigator.onLine === false) {
          // Nothing could reach Shopify: a real failure, say so, keep the input.
          e.preventDefault();
          if (this.writeError) this.writeError.hidden = false;
          return;
        }
        this.syncBody();
        this._sending = true;
        this.setWriteBusy(true);
        // If the post never leaves (captcha could not load, network dropped
        // mid-way), release the form and show the real error instead of a
        // frozen button.
        var self = this;
        clearTimeout(this._sendWatchdog);
        this._sendWatchdog = setTimeout(function () {
          self._sending = false;
          self.setWriteBusy(false);
          if (self.writeError) self.writeError.hidden = false;
        }, 20000);
        window.addEventListener('pagehide', function () { clearTimeout(self._sendWatchdog); }, { once: true });
      }

      // The email body Shopify forwards — recognisable first line, then the
      // review. Rebuilt on every change so it is always complete, even when the
      // form is completed by Shopify's spam-protection handler.
      syncBody() {
        if (!this.writeBody) return;
        var product = this.writeProduct ? this.writeProduct.value : '';
        var stars = this.selectedStars();
        var text = this.writeText ? this.writeText.value.trim() : '';
        this.writeBody.value = this.writePrefix + ' \u2014 ' + product + ' \u2014 ' + (stars || '?') + '/5\n\n' + text;
      }

      openWrite(focus) {
        this.writePanel.removeAttribute('hidden');
        this.writeToggle.setAttribute('aria-expanded', 'true');
        if (focus && this.writeStarInputs[0]) {
          var first = this.writeStarInputs[0];
          setTimeout(function () { first.focus({ preventScroll: true }); }, 0);
        }
      }

      closeWrite() {
        this.writePanel.setAttribute('hidden', '');
        this.writeToggle.setAttribute('aria-expanded', 'false');
      }

      paintStars(n) {
        this.writeStars.forEach(function (star, i) { star.classList.toggle('is-on', i < n); });
      }

      selectedStars() {
        var checked = this.writeStarInputs.filter(function (i) { return i.checked; })[0];
        return checked ? parseInt(checked.value, 10) : 0;
      }

      validEmail(v) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim());
      }

      showWriteError(key, show) {
        var el = this.writePanel.querySelector('[data-write-err="' + key + '"]');
        if (el) el.hidden = !show;
        var field = key === 'name' ? this.writeName : key === 'email' ? this.writeEmail : key === 'text' ? this.writeText : null;
        if (field) {
          if (show) field.setAttribute('aria-invalid', 'true');
          else field.removeAttribute('aria-invalid');
        }
      }

      validateWrite() {
        var ok = true;
        if (!this.selectedStars()) { this.showWriteError('stars', true); ok = false; }
        if (!this.writeName || !this.writeName.value.trim()) { this.showWriteError('name', true); ok = false; }
        if (!this.writeEmail || !this.validEmail(this.writeEmail.value)) { this.showWriteError('email', true); ok = false; }
        if (!this.writeText || !this.writeText.value.trim()) { this.showWriteError('text', true); ok = false; }
        return ok;
      }

      setWriteBusy(busy) {
        if (!this.writeSubmit) return;
        this.writeSubmit.disabled = busy;
        this.writeSubmit.textContent = busy ? this.writeSubmit.getAttribute('data-label-busy') : this.writeSubmit.getAttribute('data-label');
      }

      showWriteDone() {
        if (this.writeFields) this.writeFields.hidden = true;
        if (this.writeDoneText) {
          var name = this.writeName ? this.writeName.value.trim() : '';
          var tpl = this.writeDoneText.getAttribute('data-template') || '';
          if (name && tpl) this.writeDoneText.textContent = tpl.replace('{name}', name);
        }
        if (this.writeDone) this.writeDone.hidden = false;
        this.writeToggle.setAttribute('disabled', '');
      }


      bind() {
        var self = this;

        if (this.moreBtn) {
          this.moreBtn.addEventListener('click', function () {
            self.shown += self.reveal;
            self.render();
          });
        }

        if (this.filterBtn) {
          this.filterBtn.addEventListener('click', function () {
            self.photoOnly = !self.photoOnly;
            self.filterBtn.setAttribute('aria-pressed', String(self.photoOnly));
            self.filterBtn.classList.toggle('is-active', self.photoOnly);
            self.shown = self.initial;
            self.render();
          });
        }

        if (this.sortToggle && this.sortMenu) {
          this.sortToggle.addEventListener('click', function (e) {
            e.stopPropagation();
            self.toggleMenu();
          });

          this.sortOptions.forEach(function (opt) {
            opt.addEventListener('click', function () {
              self.sort = opt.getAttribute('data-sort') || 'recent';
              self.sortOptions.forEach(function (o) {
                o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
              });
              if (self.sortCurrent) self.sortCurrent.textContent = opt.textContent.trim();
              self.shown = self.initial;
              self.closeMenu();
              self.render();
            });
          });

          document.addEventListener('click', function (e) {
            if (self.sortRoot && !self.sortRoot.contains(e.target)) self.closeMenu();
          });

          this.sortRoot.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
              self.closeMenu();
              self.sortToggle.focus();
            }
          });
        }
      }

      toggleMenu() {
        if (this.sortMenu.hasAttribute('hidden')) this.openMenu();
        else this.closeMenu();
      }

      openMenu() {
        this.sortMenu.removeAttribute('hidden');
        this.sortToggle.setAttribute('aria-expanded', 'true');
      }

      closeMenu() {
        if (!this.sortMenu) return;
        this.sortMenu.setAttribute('hidden', '');
        this.sortToggle.setAttribute('aria-expanded', 'false');
      }

      compareRecent(a, b) {
        if (a.time !== null && b.time !== null) return b.time - a.time;
        return a.order - b.order;
      }

      comparator() {
        var self = this;
        switch (this.sort) {
          case 'featured':
            return function (a, b) {
              return a.order - b.order;
            };
          case 'oldest':
            return function (a, b) {
              if (a.time !== null && b.time !== null) return a.time - b.time;
              return b.order - a.order;
            };
          case 'rating-high':
            return function (a, b) {
              return b.rating - a.rating || self.compareRecent(a, b);
            };
          case 'rating-low':
            return function (a, b) {
              return a.rating - b.rating || self.compareRecent(a, b);
            };
          default:
            return function (a, b) {
              return self.compareRecent(a, b);
            };
        }
      }

      render() {
        var self = this;
        var filtered = this.items.filter(function (it) {
          return !self.photoOnly || it.hasPhoto;
        });
        var sorted = filtered.slice().sort(this.comparator());

        // Reorder the matching items in the DOM.
        sorted.forEach(function (it) {
          self.list.appendChild(it.el);
        });

        // Hide items removed by the filter.
        this.items.forEach(function (it) {
          if (filtered.indexOf(it) === -1) it.el.hidden = true;
        });

        // Apply the show-more window within the filtered set.
        sorted.forEach(function (it, i) {
          it.el.hidden = i >= self.shown;
        });

        // Empty state + show-more visibility.
        if (this.emptyMsg) this.emptyMsg.hidden = sorted.length !== 0;
        if (this.moreWrap) this.moreWrap.hidden = sorted.length <= this.shown;
      }

      initLightbox() {
        var self = this;
        this.lightbox = this.querySelector('[data-lightbox]');
        if (!this.lightbox) return;

        this.lbImg = this.lightbox.querySelector('[data-lb-img]');
        this.lbCloseBtn = this.lightbox.querySelector('[data-lb-close-btn]');
        this.lbPrevBtn = this.lightbox.querySelector('[data-lb-prev]');
        this.lbNextBtn = this.lightbox.querySelector('[data-lb-next]');
        this.lbCounter = this.lightbox.querySelector('[data-lb-counter]');
        this.lbFigure = this.lightbox.querySelector('.rl-lightbox__figure');
        this.lbThumbs = [];
        this.lbIndex = 0;
        this.lbOpen = false;
        this.touchX = null;

        // Open from any thumbnail (delegated, so it survives sort/filter reordering).
        this.list.addEventListener('click', function (e) {
          var thumb = e.target.closest('[data-lb-thumb]');
          if (thumb && self.list.contains(thumb)) {
            e.preventDefault();
            self.openLightbox(thumb);
          }
        });

        // Close controls: backdrop and the X button.
        Array.prototype.forEach.call(
          this.lightbox.querySelectorAll('[data-lb-close], [data-lb-close-btn]'),
          function (el) {
            el.addEventListener('click', function () { self.closeLightbox(); });
          }
        );

        if (this.lbPrevBtn) this.lbPrevBtn.addEventListener('click', function () { self.lbStep(-1); });
        if (this.lbNextBtn) this.lbNextBtn.addEventListener('click', function () { self.lbStep(1); });

        document.addEventListener('keydown', function (e) { self.onLightboxKeydown(e); });

        if (this.lbFigure) {
          this.lbFigure.addEventListener('touchstart', function (e) {
            self.touchX = e.changedTouches[0].clientX;
          }, { passive: true });
          this.lbFigure.addEventListener('touchend', function (e) {
            if (self.touchX === null || self.lbThumbs.length < 2) return;
            var dx = e.changedTouches[0].clientX - self.touchX;
            self.touchX = null;
            if (Math.abs(dx) > 40) self.lbStep(dx < 0 ? 1 : -1);
          }, { passive: true });
        }
      }

      openLightbox(thumb) {
        var media = thumb.closest('.rl-item__media');
        if (!media) return;
        // Navigation is scoped to images from the same review only.
        this.lbThumbs = Array.prototype.slice.call(media.querySelectorAll('[data-lb-thumb]'));
        this.lbIndex = this.lbThumbs.indexOf(thumb);
        if (this.lbIndex < 0) this.lbIndex = 0;
        this.lbTrigger = thumb;
        this.lbUpdate();
        this.lightbox.classList.add('is-open');
        this.lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('rl-scroll-lock');
        this.lbOpen = true;
        if (this.lbCloseBtn) this.lbCloseBtn.focus();
      }

      closeLightbox() {
        if (!this.lbOpen) return;
        this.lightbox.classList.remove('is-open');
        this.lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('rl-scroll-lock');
        this.lbOpen = false;
        if (this.lbImg) this.lbImg.removeAttribute('src');
        if (this.lbTrigger) this.lbTrigger.focus();
      }

      lbStep(dir) {
        if (this.lbThumbs.length < 2) return;
        var n = this.lbThumbs.length;
        this.lbIndex = (this.lbIndex + dir + n) % n;
        this.lbUpdate();
      }

      lbUpdate() {
        var thumb = this.lbThumbs[this.lbIndex];
        if (!thumb) return;
        var img = thumb.querySelector('img');
        var full = thumb.getAttribute('data-full');
        if (this.lbImg) {
          this.lbImg.src = full || (img ? img.src : '');
          this.lbImg.alt = img ? img.alt : '';
        }
        var multi = this.lbThumbs.length > 1;
        if (this.lbPrevBtn) this.lbPrevBtn.hidden = !multi;
        if (this.lbNextBtn) this.lbNextBtn.hidden = !multi;
        if (this.lbCounter) {
          this.lbCounter.hidden = !multi;
          if (multi) this.lbCounter.textContent = (this.lbIndex + 1) + ' / ' + this.lbThumbs.length;
        }
      }

      onLightboxKeydown(e) {
        if (!this.lbOpen) return;
        if (e.key === 'Escape') {
          this.closeLightbox();
        } else if (e.key === 'ArrowLeft') {
          this.lbStep(-1);
        } else if (e.key === 'ArrowRight') {
          this.lbStep(1);
        } else if (e.key === 'Tab') {
          this.lbTrapFocus(e);
        }
      }

      lbTrapFocus(e) {
        var focusable = [this.lbCloseBtn];
        if (this.lbPrevBtn && !this.lbPrevBtn.hidden) focusable.push(this.lbPrevBtn);
        if (this.lbNextBtn && !this.lbNextBtn.hidden) focusable.push(this.lbNextBtn);
        focusable = focusable.filter(Boolean);
        if (focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (focusable.indexOf(document.activeElement) === -1) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('reviews-list-controller', ReviewsListController);
  }

  } catch(e) { console.error(e); }
})();
})();
